import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n    overflow: hidden;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { fromTo, trail, val } from 'light-trails';
import React, { useRef } from 'react';
import styled from 'styled-components';
import { useElementSize } from '../../hooks/useElementSize';
import { useStep } from '../../hooks/useStep';
export const SwapItem = props => {
  const ref = useRef(null);
  const size = useElementSize(ref);
  useStep(props.in, ({
    duration
  }) => trail(ref.current, [fromTo({
    height: val(0, size.height, 'px'),
    opacity: val(0, 1)
  }, duration.normal)]), {
    title: '→SwapItem',
    deps: [size !== null]
  });
  useStep(props.out, ({
    duration
  }) => trail(ref.current, [fromTo({
    height: val(size.height, 0, 'px'),
    opacity: val(1, 0),
    y: val(0, -100, '%')
  }, duration.normal)]), {
    title: '←SwapItem',
    deps: [size !== null]
  });
  return React.createElement(Container, {
    ref: ref
  }, props.children);
};
const Container = styled.div(_templateObject());